import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { agreementAcceptFlag } from "../store/slices/agreementAcceptFlag";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { parseShopifyHost } from "../utils/parseShopifyHost";
import "bootstrap/dist/css/bootstrap.min.css";

export function Agreement(props) {
  const dispatch = useDispatch();

  const { isShopifyApp , shopName} = parseShopifyHost();

  const agreementAccepted = useSelector(
    (state) => state.agreement?.accepted
  );

  const AggreementFlag = useSelector(
    (state) => state.storeLimit?.isAgreementAccepted
  );

  const [modalShow, setModalShow] = useState(false);
  const [agreementAcceptCheck, setAgreementAcceptCheck] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!isShopifyApp) return;

    // Open modal only if agreement not accepted
    if (typeof AggreementFlag === "boolean") {
      if (isShopifyApp && !AggreementFlag) {
        setModalShow(true);
      } else {
        setModalShow(false);
      }
    }
  }, [AggreementFlag, isShopifyApp]);

  const handleAgree = () => {
    if (!agreementAcceptCheck) {
      setShowWarning(true);
      return;
    }
    // Pass only one boolean argument
    dispatch(agreementAcceptFlag({targetStoreHash: shopName}));

    setModalShow(false);
    setShowWarning(false);
  };

  if (!isShopifyApp) {
    return null;
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={modalShow}
      className="agreement-Popup"
      onHide={() => setModalShow(false)}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="fw-bold"
        >
          Terms & Conditions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className="text-center my-4">
          TECHNOLOGY SERVICES AGREEMENT
        </h4>
        <ol>
          <li className="mb-3">
            <b>Acceptance of Terms.</b> By installing, accessing, subscribing to, or
            using any StrikeTru application, connector, software, or related services
            (collectively, the "Services"), the customer ("Client") agrees to be bound
            by this Agreement. If the individual accepting this Agreement is acting on
            behalf of a company or other legal entity, such individual represents and
            warrants that they have authority to bind such entity.
          </li>

          <li className="mb-3">
            <b>License Grant.</b> Subject to Client's compliance with this Agreement
            and payment of all applicable fees, StrikeTru grants Client a limited,
            non-exclusive, non-transferable, revocable subscription license to access
            and use the Services during the subscription term. No ownership rights are
            transferred to the client. All rights not expressly granted herein are
            reserved by StrikeTru.
          </li>

          <li className="mb-3">
            <b>Access to Platform Data.</b> Client authorizes StrikeTru to access,
            retrieve, process, store, modify, and synchronize data from Client's
            connected platforms, including but not limited to: Shopify, BigCommerce,
            Akeneo, TruPIM, and other third-party applications, solely for the purpose
            of providing the Services. Client is solely responsible for ensuring it
            has all rights, permissions, and authority necessary to provide such
            access.
          </li>

          <li className="mb-3">
            <b>Client Data Ownership.</b> Client retains all ownership rights to its
            products, content, catalog data, images, pricing, customer information,
            and other data provided to or processed by the Services ("Client Data").
            StrikeTru acquires no ownership rights in Client Data. Client grants
            StrikeTru a limited right to use Client Data solely as necessary to
            provide, support, maintain, improve, and operate the Services.
          </li>

          <li className="mb-3">
            <b>Subscription Fees.</b> Subscription fees shall be billed through the
            applicable platform marketplace, direct invoice, or another agreed payment
            method. Unless otherwise stated, fees are due in advance, are
            non-refundable, and unused subscription periods are non-refundable.
            Failure to pay may result in suspension or termination of Services.
            StrikeTru reserves the right to modify pricing upon renewal or as
            permitted by the applicable marketplace platform.
          </li>

          <li className="mb-3">
            <b>Service Availability.</b> StrikeTru will use commercially reasonable
            efforts to maintain availability of the Services. The Services may be
            temporarily unavailable due to maintenance activities, platform outages,
            third-party service failures, internet interruptions, or force majeure
            events. StrikeTru does not guarantee uninterrupted operation of the
            Services.
          </li>

          <li className="mb-3">
            <b>Updates and Enhancements.</b> StrikeTru may release updates,
            improvements, bug fixes, modifications, or new features at its discretion.
            StrikeTru may modify, replace, discontinue, or remove features at any
            time. Continued use of the Services constitutes acceptance of such
            changes.
          </li>

          <li className="mb-3">
            <b>Support Services.</b> Support services are provided in accordance with
            StrikeTru's then-current support policies. Premium support, implementation
            services, customizations, integrations, and consulting services may
            require separate fees.
          </li>

          <li className="mb-3">
            <b>Marketing, Publicity, and Customer References.</b> Client grants
            StrikeTru the right to identify Client as a customer, display Client's
            company name, logo, website URL, and publicly available brand assets, and
            reference Client's use of the Services in sales materials, presentations,
            proposals, websites, social media, case studies, webinars, conferences,
            and marketing campaigns. StrikeTru may publish general descriptions of the
            business relationship and results achieved. StrikeTru agrees not to
            disclose Client's confidential information without consent. Client may opt
            out of case studies requiring detailed business information upon written
            request.
          </li>

          <li className="mb-3">
            <b>Acceptable Use.</b> Client shall not reverse engineer the Services,
            attempt unauthorized access, circumvent licensing restrictions, use the
            Services for unlawful purposes, or interfere with operation of the
            Services. StrikeTru may immediately suspend access for violations of this
            section.
          </li>

          <li className="mb-3">
            <b>Confidential Information.</b> Each party shall protect the other
            party's confidential information using reasonable care. Confidential
            information shall not include information that is publicly available, was
            lawfully known prior to disclosure, is independently developed, or is
            required to be disclosed by law.
          </li>

          <li className="mb-3">
            <b>Disclaimer of Warranties.</b> THE SERVICES ARE PROVIDED "AS IS," "AS
            AVAILABLE," AND WITHOUT WARRANTIES OF ANY KIND. STRIKETRU DISCLAIMS ALL
            EXPRESS, IMPLIED, STATUTORY, AND OTHER WARRANTIES, INCLUDING WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND
            ACCURACY. STRIKETRU DOES NOT WARRANT THAT THE SERVICES WILL BE
            ERROR-FREE, THAT THIRD-PARTY PLATFORMS WILL ALWAYS REMAIN COMPATIBLE, OR
            THAT THE SERVICES WILL OPERATE WITHOUT INTERRUPTION.
          </li>

          <li className="mb-3">
            <b>Limitation of Liability.</b> TO THE MAXIMUM EXTENT PERMITTED BY LAW,
            STRIKETRU SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, INCLUDING WITHOUT
            LIMITATION LOST PROFITS, LOST REVENUE, LOSS OF DATA, BUSINESS
            INTERRUPTION, OR LOSS OF GOODWILL, ARISING OUT OF OR RELATED TO THE
            SERVICES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </li>

          <li className="mb-3">
            <b>Indemnification.</b> Client agrees to defend, indemnify, and hold
            harmless StrikeTru and its affiliates, officers, directors, employees,
            contractors, and partners from claims arising from Client Data, Client's
            misuse of the Services, Client's violation of laws, Client's violation of
            third-party rights, or Client's breach of this Agreement.
          </li>

          <li className="mb-3">
            <b>Suspension and Termination.</b> StrikeTru may suspend or terminate
            Services immediately if subscription fees are unpaid, Client violates this
            Agreement, Client misuses the Services, or continued service creates
            legal, operational, or security risks. Client may terminate the Services
            by uninstalling the application or canceling the subscription through the
            applicable platform. Termination does not relieve Client of payment
            obligations accrued prior to termination.
          </li>

          <li className="mb-3">
            <b>Data Retention Following Termination.</b> Following termination or
            uninstall, Client access will cease. StrikeTru may retain Client
            configurations for up to thirty (30) days for backup, compliance, and
            recovery purposes, after which StrikeTru may permanently delete Client
            configurations. StrikeTru is under no obligation to maintain Client Data
            following termination.
          </li>

          <li className="mb-3">
            <b>Governing Law.</b> This Agreement shall be governed by and construed
            under the laws of the State of Texas, without regard to conflict of law
            principles.
          </li>

          <li className="mb-3">
            <b>Arbitration.</b> Any dispute arising under this Agreement shall be
            resolved through binding arbitration in Houston, Texas. The arbitration
            shall be conducted in English before a single arbitrator. The arbitrator's
            decision shall be final and binding.
          </li>

          <li className="mb-3">
            <b>Force Majeure.</b> StrikeTru shall not be liable for delays or failures
            caused by events beyond its reasonable control, including natural
            disasters, government actions, internet outages, cyber attacks, labor
            disputes, platform outages, or third-party service failures.
          </li>

          <li className="mb-3">
            <b>Electronic Acceptance.</b> By installing, enabling, purchasing,
            subscribing to, or using the Services, Client electronically agrees to
            this Agreement and acknowledges that such acceptance constitutes a legally
            binding electronic signature.
          </li>
        </ol>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <div className="accept-check d-flex align-items-center">
          <Form.Check
            label="I accept"
            type="checkbox"
            id="agreement-checkbox"
            checked={agreementAcceptCheck}
            onChange={(e) => {
              setAgreementAcceptCheck(e.target.checked);

              if (e.target.checked) {
                setShowWarning(false);
              }
            }}
          />

          {showWarning && (
            <span className="badge bg-danger ms-3">
              Please accept the agreement
            </span>
          )}
        </div>

        <div className="action-buttons">

          <Button variant="primary" onClick={handleAgree}>
            Agree & Continue
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default Agreement;